import { AccountStatusesEnum } from '../enums/AccountStatusesEnum';
import { IAccountState } from '../interfaces/IAccountState';

const organizationsInitialState = {
  data: {
    kno: [],
    prosecutor: [],
  },
  status: AccountStatusesEnum.IDLE,
  error: undefined,
};

export const initialAccountState: IAccountState = {
  checklistTemplates: {},
  requirementTemplates: {},
  organizationsWithDistrict: organizationsInitialState,
  knoOrganizationFunctions: {},
  organizations: organizationsInitialState,
};
